// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_do-b";
export var colorBlue = "_do-8";
export var colorDot = "_do-0";
export var colorDotLarge = "_do-2";
export var colorDotSmall = "_do-1";
export var colorGreen = "_do-7";
export var colorGrey = "_do-3";
export var colorOrange = "_do-5";
export var colorPink = "_do-a";
export var colorPurple = "_do-9";
export var colorRed = "_do-4";
export var colorYellow = "_do-6";